// File: frontend/src/components/customTopics/CustomTopicList.tsx
// src/components/customTopics/CustomTopicList.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import "./CustomTopicRow.css";
import { CustomTopicModel } from "../../models/CustomTopicModel";
import { CustomTopicRow } from "./CustomTopicRow";
// Sitewide pins: badge wrapper for the admin-pinned topic row
import { PinnedTopicWrap } from "../common/PinnedTopicWrap";

interface CustomTopicListProps {
  topics: CustomTopicModel[];
  selectedTopicId: number | null;
  onSelectTopic: (topicId: number) => void;
  // Forwarded to each CustomTopicRow for mobile pane switching
  onMobileNavigate?: () => void;
  // ID of the admin-pinned custom topic (null = nothing pinned)
  pinnedTopicId?: number | null;
}

export const CustomTopicList: React.FC<CustomTopicListProps> = ({
  topics,
  selectedTopicId,
  onSelectTopic,
  onMobileNavigate,
  pinnedTopicId = null,
}) => {
  const { t } = useTranslation();

  if (!topics || topics.length === 0) {
    return (
      <div className="person-list__empty">
        <p>{t("topics_not_found", "Özel başlık bulunamadı.")}</p>
      </div>
    );
  }

  return (
    <div className="person-list">
      {topics.map(topic => (
        <PinnedTopicWrap key={topic.id} pinned={topic.id === pinnedTopicId}>
        <CustomTopicRow
          topic={topic}
          isSelected={topic.id === selectedTopicId}
          onSelect={() => onSelectTopic(topic.id)}
          onMobileNavigate={onMobileNavigate}
        />
        </PinnedTopicWrap>
      ))}
    </div>
  );
};